import React, { useCallback } from 'react'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_SHOPIFY_CANCEL_ORDER } from 'ducks/drawers/types'
import { Button } from 'util/ui'
import { buildDrawerQueryParam } from 'ducks/drawers/util'

const CancelOrderButton = ({
  integration,
  orderId,
  unpaid,
  refundAmount,
  currencyCode,
  disabled,
}) => {
  const { openDrawer, drawerId } = useDrawer({
    type: DRAWER_TYPE_SHOPIFY_CANCEL_ORDER,
  })

  const onOpen = useCallback(
    () => {
      openDrawer(orderId, {
        query: {
          ...buildDrawerQueryParam(
            drawerId,
            'drawerIntegrationId',
            integration.id
          ),
        },
        additionalProps: {
          integration,
          orderId,
          unpaid,
          refundAmount,
          currencyCode,
        },
      })
    },
    [
      openDrawer,
      integration,
      orderId,
      unpaid,
      refundAmount,
      currencyCode,
      drawerId,
    ]
  )

  return (
    <Button basic onClick={onOpen} disabled={disabled}>
      Cancel
    </Button>
  )
}

export default CancelOrderButton
